/**
 * Chargement / mapping patient + cas pour les fiches (IPR, production).
 */

export const CASE_SHEET_SELECT = `
  id, case_number, case_type, treatment_type, created_date, user_profile_id,
  patient:patients!cases_patient_id_fkey(
    name, patient_code, date_birth, phone, email, location
  ),
  dentist:user_profiles!cases_user_profile_id_fkey(
    id, full_name, email, company_name
  )
`;

export function mapCaseToSheetPatientData(caseInfo) {
  if (!caseInfo) return null;
  return {
    caseId: caseInfo.id,
    dentistId: caseInfo.user_profile_id || caseInfo.dentist?.id || null,
    patientName: caseInfo.patient?.name || '—',
    patientId: caseInfo.patient?.patient_code || '—',
    caseNumber: caseInfo.case_number || '—',
    dateOfBirth: caseInfo.patient?.date_birth
      ? new Date(caseInfo.patient.date_birth).toLocaleDateString('fr-FR')
      : '—',
    dentistName: caseInfo.dentist?.full_name || '—',
    clinicName: caseInfo.dentist?.company_name || '—',
    createdDate: caseInfo.created_date
      ? new Date(caseInfo.created_date).toLocaleDateString('fr-FR')
      : '—',
    treatmentType: caseInfo.treatment_type || 'Aligneurs',
  };
}
